module.exports = __webpack_public_path__ + "static/media/addvalues2.6da1c1c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/addvalues2.jpg
// module id = 1634
// module chunks = 0